import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { INTEGRATIONS_LIST_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_integrations_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { useOrgProject } from '@/context/OrgProjectContext/useOrgProject.ts';
import { IntegrationProviders } from '@/types/integrations.ts';

const useRetrieveIntegrations = (): UseQueryResult<IntegrationProviders, AxiosError> => {
  const apiClient = useApiClient();
  const { projectId } = useOrgProject();

  return useQuery({
    queryKey: INTEGRATIONS_LIST_KEY(projectId),
    queryFn: async () => {
      const response = await apiClient.get(get_integrations_url(projectId));
      return response.data;
    },
    enabled: !!projectId,
  });
};

export default useRetrieveIntegrations;
